import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Layout } from "../components/Layout";
import { Funnel, MapPin, Heart, ArrowRight, HandHeart, Sparkle } from "@phosphor-icons/react";

export default function SponsorshipPrograms() {
  const [skills, setSkills] = useState([]);
  const [items, setItems] = useState([]);
  const [skill, setSkill] = useState("");
  const [location, setLocation] = useState("");

  useEffect(() => { api.get("/skills").then(({ data }) => setSkills(data.skills)); }, []);
  useEffect(() => {
    const params = new URLSearchParams();
    if (skill) params.set("skill", skill);
    if (location) params.set("location", location);
    api.get(`/sponsorship-programs?${params.toString()}`).then(({ data }) => setItems(data));
  }, [skill, location]);

  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="flex items-center justify-between flex-wrap gap-3 mb-8">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.18em] text-[var(--as-accent)] flex items-center gap-2">
              <Sparkle size={14} weight="fill" /> Sponsored skill programs · CSR / Foundation funded
            </div>
            <h1 className="text-3xl sm:text-4xl font-bold text-[var(--as-primary)] mt-1" style={{fontFamily:"Inter"}}>
              Get verified — at zero cost to you.
            </h1>
            <p className="text-[var(--as-text-secondary)] mt-2 max-w-3xl leading-relaxed">
              These programs cover your skill verification, badges, and discoverability — funded by Indian
              corporates, foundations, and patrons. Apply if you fit the target trade and location.
            </p>
          </div>
          <Link to="/donate" className="btn-primary !py-3 !px-5" data-testid="program-list-donate">
            <Heart size={18} weight="duotone" /> Power a Worker
          </Link>
        </div>

        <div className="as-card p-5 grid md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="as-label flex items-center gap-1.5"><Funnel size={14} weight="duotone" />Trade / skill</label>
            <select className="as-input" value={skill} onChange={(e) => setSkill(e.target.value)} data-testid="program-filter-skill">
              <option value="">All trades</option>
              {skills.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label className="as-label">Location</label>
            <input className="as-input" value={location} onChange={(e) => setLocation(e.target.value)} placeholder="Bengaluru" data-testid="program-filter-loc" />
          </div>
        </div>

        {items.length === 0 ? (
          <div className="as-card p-10 text-center text-[var(--as-text-secondary)]">No programs match your filters.</div>
        ) : (
          <div className="grid md:grid-cols-2 gap-5">
            {items.map((p) => {
              const pct = Math.round((p.slots_used / p.slots) * 100);
              return (
                <Link to={`/sponsorship-programs/${p.id}`} key={p.id} className="as-card p-6 hover:-translate-y-1" data-testid={`program-card-${p.id}`}>
                  <div className="flex items-start justify-between gap-2">
                    <span className="as-badge-pill">{p.sponsor_type.replace("_", " ")}</span>
                    <span className="text-xs font-bold text-[var(--as-text-secondary)]">{p.slots_used}/{p.slots} slots</span>
                  </div>
                  <h3 className="text-xl font-bold mt-3 text-[var(--as-primary)]" style={{fontFamily:"Inter"}}>{p.title}</h3>
                  <p className="text-sm text-[var(--as-text-secondary)] mt-2 line-clamp-2 leading-relaxed">{p.description}</p>

                  <div className="mt-4">
                    <div className="h-2 bg-[var(--as-bg-alt)] rounded-full overflow-hidden">
                      <div className="h-full bg-[var(--as-accent)]" style={{width: `${pct}%`}} />
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-1.5 mt-4">
                    {(p.target_skills || []).slice(0, 3).map((s) => (
                      <span key={s} className="as-badge-skill !text-xs">{s}</span>
                    ))}
                  </div>

                  <div className="mt-4 pt-4 border-t border-[var(--as-border)] flex items-center justify-between text-xs text-[var(--as-text-secondary)]">
                    <span className="font-bold text-[var(--as-primary)]">{p.sponsor_name}</span>
                    <span className="inline-flex items-center gap-1.5"><MapPin size={14} weight="duotone" />{(p.target_locations || []).slice(0,2).join(", ") || "Anywhere"}</span>
                    <ArrowRight size={16} weight="bold" />
                  </div>
                </Link>
              );
            })}
          </div>
        )}

        <div className="mt-12 as-card p-7 bg-[var(--as-bg-alt)]">
          <div className="flex flex-wrap items-start gap-4 justify-between">
            <div>
              <HandHeart size={28} weight="duotone" color="#00B7A6" />
              <h3 className="text-xl font-bold mt-2 text-[var(--as-primary)]" style={{fontFamily:"Inter"}}>Are you a corporate, foundation, or patron?</h3>
              <p className="text-[var(--as-text-secondary)] mt-1 max-w-2xl">
                Sponsor a cohort of workers or MSMEs. Get an audit-grade impact dashboard, co-branded badges, and Schedule VII compliance baked in.
              </p>
            </div>
            <Link to="/register?role=sponsor" className="btn-primary" data-testid="become-sponsor">
              Become a sponsor <ArrowRight size={18} weight="bold" />
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
